import { faClock } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { parseApiDate } from '@propertypal/shared/src/services/dayjs';
import React from 'react';
import { useTheme } from 'styled-components';
import { Box } from '../layout';
import { Text } from '../typography';

interface StartEndTimeProps {
  startTime?: string;
  endTime?: string;
  propBoxAuction?: boolean;
  cancelled?: boolean;
}

const StartEndTime: React.FC<StartEndTimeProps> = ({ startTime, endTime, propBoxAuction, cancelled }) => {
  const theme = useTheme();

  const color = cancelled ? theme.primary : theme.textDark;

  const getTime = () => {
    if (cancelled) return 'CANCELLED';
    if (!startTime) return <>&nbsp;</>;
    let prefix = '';
    if (propBoxAuction) prefix = 'Auction ';
    const timeFormat = 'hh:mma';
    const format = propBoxAuction ? `MMM DD: ${timeFormat}` : timeFormat;
    const start = parseApiDate(startTime).format(format);
    if (!endTime || startTime === endTime) return `${prefix}${start}`;
    const end = parseApiDate(endTime).format(format);
    return `${start} - ${end}`;
  };

  return (
    <Box display="flex" flexFlow="row" alignItems="center" mb={8} data-testid="start-end-time">
      <Box flexBasis="16px" mr={10}>
        {startTime && <FontAwesomeIcon icon={faClock} data-testid="clock-icon" color={color} />}
      </Box>
      <Box flexBasis="calc(100% - 16px - 10px)">
        <Text lineHeight={24} fontWeight="bold" data-testid="date-text" color={color}>
          {getTime()}
        </Text>
      </Box>
    </Box>
  );
};

export default StartEndTime;
